module.exports = __webpack_public_path__ + "img/w矩形 86@3x.b565700f.png";